<template>
  <div class="page-container">
    <div class="auth-box">
      <h1 class="auth-title">{{ $t('register') }}</h1>

      <div class="auth-form">
        <input
          v-model="username"
          class="input-field"
          :placeholder="$t('username')"
        />
        <p class="field-hint text-xs text-tertiary mt-1">{{ $t('username_rule') }}</p>
        <input
          v-model="password"
          type="password"
          class="input-field mt-1"
          :placeholder="$t('password')"
        />
        <p class="field-hint text-xs text-tertiary mt-1">{{ $t('password_rule') }}</p>
        <input
          v-model="confirmPassword"
          type="password"
          class="input-field mt-1"
          :placeholder="$t('confirm_password')"
        />
        <p v-if="error" class="auth-error">{{ error }}</p>
        <button class="btn btn-primary mt-2" style="width:100%" @click="handleRegister" :disabled="loading">
          {{ loading ? '...' : $t('register') }}
        </button>
      </div>

      <p class="auth-switch mt-2 text-sm text-center">
        <router-link to="/login" class="text-secondary">{{ $t('login') }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { register } from '../api'

export default {
  name: 'Register',
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      error: '',
      loading: false
    }
  },
  methods: {
    handleRegister() {
      this.error = ''
      if (!this.username || !this.password) {
        this.error = this.$t('username_rule')
        return
      }
      if (this.password !== this.confirmPassword) {
        this.error = '两次输入的密码不一致'
        return
      }
      if (this.password.length < 6 || this.password.length > 24) {
        this.error = this.$t('password_rule')
        return
      }
      this.loading = true
      register(this.username, this.password).then(res => {
        const d = res.data.data
        localStorage.setItem('markjy_token', d.token)
        localStorage.setItem('markjy_username', d.username)
        localStorage.setItem('markjy_is_admin', 'false')
        localStorage.setItem('markjy_user_id', d.user_id)
        this.$router.push('/')
      }).catch(err => {
        const msg = err.response && err.response.data ? err.response.data.message : this.$t('network_error')
        this.error = msg
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.auth-box {
  max-width: 380px;
  margin: 60px auto 0;
}
.auth-title {
  font-size: 1.3rem;
  font-weight: 600;
  text-align: left;
  margin-bottom: 24px;
}
.auth-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.field-hint {
  margin-top: 4px;
  margin-bottom: 0;
}
.auth-error {
  color: #d32f2f;
  font-size: 0.8rem;
  margin-top: 8px;
}
.auth-switch a {
  text-decoration: underline;
}
</style>
